// Domain validation shared by the API (authoritative check) and the portals
// (pre-flight input validation) — one source of truth for the rules.

/** Lowercase DNS hostname: 1-253 chars, dot-separated labels, TLD of 2+ letters. */
export const DOMAIN_PATTERN =
  /^(?=.{1,253}$)([a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,}$/;

/**
 * Trim + lowercase a candidate domain and validate it. Returns the normalised
 * hostname, or null when the input isn't a valid domain.
 */
export function normalizeDomain(value: unknown): string | null {
  if (typeof value !== "string") return null;
  const normalized = value.trim().toLowerCase();
  return DOMAIN_PATTERN.test(normalized) ? normalized : null;
}
